import {
  LOADED_FAIL_USERS,
  LOADED_USERS,
  LOADING_USERS,
  VERIFIED_FAIL_USER,
  VERIFIED_USER,
  VERIFYING_USER,
  LOADED_UL20_USERS,
  LOADED_FAIL_UL20_USERS,
  LINK_BILLING_ACCOUNT_ID_SUCCESS,
  LINK_BILLING_ACCOUNT_ID_FAILED,
  LINK_BILLING_ACCOUNT_ID_LOADING,
  LOADED_NUMEN_BILLING_PRACTICE,
  LOADED_FAIL_NUMEN_BILLING_PRACTICE,
  LOADING_NUMEN_BILLING_PRACTICE,
  LOADED_REFRESH_NUMEN_BILLING_PRACTICE,
  EDITED_NUMEN_BILLING_PRACTICE,
  EDITED_FAIL_NUMEN_BILLING_PRACTICE,
  EDITING_NUMEN_BILLING_PRACTICE,
  USER_MAKE_PREPAID_FAILED,
  USER_MAKE_PREPAID_SUCCESS,
  OMITTING_USER,
  OMITTED_USERS,
  OMITTED_FAIL_USERS,
  HOLDING_USER,
  HELD_USER,
  HELD_FAIL_USER,
  LOADING_OFFICE_USERS,
  LOADED_OFFICE_USERS,
  LOADED_FAIL_OFFICE_USERS,
  MODIFYING_OFFICE_USER_ROLES,
  MODIFIED_OFFICE_USER_ROLES,
  MODIFY_FAIL_OFFICE_USER_ROLES,
  REMOVING_OFFICE_USER,
  REMOVED_OFFICE_USER,
  REMOVE_FAIL_OFFICE_USER,
  ADDING_OFFICE_USER,
  ADDED_OFFICE_USER,
  ADD_FAIL_OFFICE_USER,
  RESETTING_CUSTOMER_PASSWORD,
  RESET_CUSTOMER_PASSWORD_SUCCESS,
  RESET_CUSTOMER_PASSWORD_FAILED,
  MAKING_CUSTOMER_OFFICE_DELINQUENT,
  MADE_CUSTOMER_OFFICE_DELINQUENT,
  MAKE_CUSTOMER_OFFICE_DELINQUENT_FAILED,
  MAKING_OFFICE_HIDE_INVOICE,
  MADE_OFFICE_HIDE_INVOICE,
  MAKE_OFFICE_HIDE_INVOICE_FAILED,
} from '../actions/types';

const initialState = {
  loading: false,
  users: {
    contents: [],
    totalPages: 0,
    currentPage: 0,
  },
  ul20Users: {
    contents: [],
    totalPages: 0,
    currentPage: 0,
  },
  officeUsers: {
    contents: [],
    totalPages: 0,
    currentPage: 0,
  },
  updating: false,
  verified: false,
  hold: false,
  loadingOmit: false,
  omitted: false,
  errorOmit: false,
  errorMessageOmit: '',
  loadingVerify: false,
  loadingHold: false,
  errorVerified: false,
  errorVerifiedMessage: '',
  errorHold: false,
  errorHoldMessage: '',
  loadingLinkId: false,
  errorLinkId: false,
  successLinkId: false,
  errorLinkIdMessage: '',
  successPrepaid: false,
  errorPrepaid: false,
  bpLoading: false,
  bpEditing: false,
  bpEditStatus: null,
  userBillingPracticeSelected: {},
  bpLoadError: null,
  bpEditErrorMessage: null,
  loadingOfficeUsers: false,
  modifyingRoles: false,
  modifiedRoles: false,
  errorModifyRoles: false,
  errorModifyRolesMessage: '',
  removingUser: false,
  removedUser: false,
  errorRemoveUser: false,
  errorRemoveUserMessage: '',
  addingUser: false,
  addedUser: false,
  errorAddUser: false,
  errorAddUserMessage: '',
  resettingCustomerPassword: false,
  resetCustomerPasswordSuccess: false,
  resetCustomerPasswordError: false,
  resetCustomerPasswordErrorMessage: '',
  makingCustomerOfficeDelinquent: false,
  madeCustomerOfficeDelinquent: false,
  errorMakeCustomerOfficeDelinquent: false,
  errorMakeCustomerOfficeDelinquentMessage: '',
  makingOfficeHideInvoice: false,
  madeOfficeHideInvoice: false,
  errorMakeOfficeHideInvoice: false,
  errorMakeOfficeHideInvoiceMessage: '',
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case VERIFYING_USER:
      return {
        ...state,
        loadingVerify: true,
        verified: false,
        errorVerified: false,
      };
    case VERIFIED_USER:
      return {
        ...state,
        loadingVerify: false,
        verified: true,
        errorVerified: false,
      };
    case VERIFIED_FAIL_USER:
      return {
        ...state,
        loadingVerify: false,
        verified: false,
        errorVerified: true,
        errorVerifiedMessage: action.payload,
      };
    case HOLDING_USER:
      return {
        ...state,
        loadingHold: true,
        hold: false,
        errorHold: false,
      };
    case HELD_USER:
      return {
        ...state,
        loadingHold: false,
        hold: true,
        errorHold: false,
      };
    case HELD_FAIL_USER:
      return {
        ...state,
        loadingHold: false,
        hold: false,
        errorHold: true,
        errorHoldMessage: action.payload,
      };
    case LOADED_USERS:
      return {
        ...state,
        users: action.payload,
        loading: false,
        updating: false,
        loadingVerify: false,
        loadingHold: false,
        loadingLinkId: false,
        errorLinkId: false,
        successLinkId: false,
        errorVerifiedMessage: '',
        errorHoldMessage: '',
        verified: false,
        hold: false,
        successPrepaid: false,
        errorPrepaid: false,
        errorOmit: false,
        omitted: false,
        resettingCustomerPassword: false,
        resetCustomerPasswordSuccess: false,
        resetCustomerPasswordError: false,
        resetCustomerPasswordErrorMessage: '',
        makingCustomerOfficeDelinquent: false,
        madeCustomerOfficeDelinquent: false,
        errorMakeCustomerOfficeDelinquent: false,
        errorMakeCustomerOfficeDelinquentMessage: '',
      };
    case LOADING_USERS:
      return {
        ...state,
        loading: true,
        successPrepaid: false,
        errorPrepaid: false,
        loadingVerify: false,
        loadingHold: false,
      };
    case LOADED_FAIL_USERS:
    case LOADED_FAIL_UL20_USERS:
      return {
        ...state,
        error: true,
        loading: false,
        verified: false,
        hold: false,
        successPrepaid: false,
        errorPrepaid: false,
      };
    case LOADED_UL20_USERS:
      return {
        ...state,
        ul20Users: action.payload,
        loading: false,
        updating: false,
        loadingVerify: false,
        loadingHold: false,
        loadingLinkId: false,
        errorLinkId: false,
        successLinkId: false,
        verified: false,
        hold: false,
        successPrepaid: false,
        errorPrepaid: false,
        resettingCustomerPassword: false,
        resetCustomerPasswordSuccess: false,
        resetCustomerPasswordError: false,
        resetCustomerPasswordErrorMessage: '',
      };
    case LINK_BILLING_ACCOUNT_ID_SUCCESS:
      return {
        ...state,
        successLinkId: true,
        errorLinkId: false,
      };
    case LINK_BILLING_ACCOUNT_ID_FAILED:
      return {
        ...state,
        successLinkId: false,
        errorLinkId: true,
        errorLinkIdMessage: action.payload,
      };
    case LINK_BILLING_ACCOUNT_ID_LOADING:
      return {
        ...state,
        loadingLinkId: true,
        errorLinkId: false,
        successLinkId: false,
      };

    case LOADED_NUMEN_BILLING_PRACTICE:
      return {
        ...state,
        bpLoading: false,
        userBillingPracticeSelected: action.payload,
        bpLoadError: null,
      };

    case LOADED_FAIL_NUMEN_BILLING_PRACTICE:
      return {
        ...state,
        bpLoading: false,
        bpLoadError: action.payload,
        userBillingPracticeSelected: {},
      };

    case LOADING_NUMEN_BILLING_PRACTICE:
      return {
        ...state,
        bpLoading: true,
        bpLoadError: null,
        userBillingPracticeSelected: {},
      };

    case LOADED_REFRESH_NUMEN_BILLING_PRACTICE:
      return {
        ...state,
        bpLoading: false,
        bpLoadError: null,
        bpEditStatus: null,
        bpEditing: false,
        userBillingPracticeSelected: {},
        bpEditErrorMessage: null,
      };

    case EDITING_NUMEN_BILLING_PRACTICE:
      return {
        ...state,
        bpEditing: true,
        bpEditStatus: null,
      };

    case EDITED_NUMEN_BILLING_PRACTICE:
      return {
        ...state,
        bpEditing: false,
        bpEditStatus: 'SUCCESS',
        userBillingPracticeSelected: action.payload,
      };

    case EDITED_FAIL_NUMEN_BILLING_PRACTICE:
      return {
        ...state,
        bpEditing: false,
        bpEditStatus: 'ERROR',
        bpEditErrorMessage: action.payload,
      };

    case USER_MAKE_PREPAID_SUCCESS:
      return {
        ...state,
        successPrepaid: true,
        errorPrepaid: false,
      };
    case USER_MAKE_PREPAID_FAILED:
      return {
        ...state,
        successPrepaid: false,
        errorPrepaid: true,
      };
    case OMITTING_USER:
      return {
        ...state,
        loadingOmit: true,
      };
    case OMITTED_USERS:
      return {
        ...state,
        loadingOmit: false,
        omitted: true,
      };
    case OMITTED_FAIL_USERS:
      return {
        ...state,
        loadingOmit: false,
        errorOmit: true,
        errorMessageOmit: action.payload,
      };
    case LOADING_OFFICE_USERS:
      return {
        ...state,
        loadingOfficeUsers: true,
        modifiedRoles: false,
        errorModifyRoles: false,
        removedUser: false,
        errorRemoveUser: false,
        addedUser: false,
        errorAddUser: false,
      };
    case LOADED_OFFICE_USERS:
      return {
        ...state,
        officeUsers: action.payload,
        loadingOfficeUsers: false,
        modifyingRoles: false,
        modifiedRoles: false,
        errorModifyRoles: false,
        removingUser: false,
        removedUser: false,
        errorRemoveUser: false,
        addingUser: false,
        addedUser: false,
        errorAddUser: false,
      };
    case LOADED_FAIL_OFFICE_USERS:
      return {
        ...state,
        loadingOfficeUsers: false,
      };
    case MODIFYING_OFFICE_USER_ROLES:
      return {
        ...state,
        modifyingRoles: true,
        modifiedRoles: false,
        errorModifyRoles: false,
      };
    case MODIFIED_OFFICE_USER_ROLES:
      return {
        ...state,
        modifyingRoles: false,
        modifiedRoles: true,
        errorModifyRoles: false,
      };
    case MODIFY_FAIL_OFFICE_USER_ROLES:
      return {
        ...state,
        modifyingRoles: false,
        modifiedRoles: false,
        errorModifyRoles: true,
        errorModifyRolesMessage: action.payload,
      };
    case REMOVING_OFFICE_USER:
      return {
        ...state,
        removingUser: true,
        removedUser: false,
        errorRemoveUser: false,
      };
    case REMOVED_OFFICE_USER:
      return {
        ...state,
        removingUser: false,
        removedUser: true,
        errorRemoveUser: false,
      };
    case REMOVE_FAIL_OFFICE_USER:
      return {
        ...state,
        removingUser: false,
        removedUser: false,
        errorRemoveUser: true,
        errorRemoveUserMessage: action.payload,
      };
    case ADDING_OFFICE_USER:
      return {
        ...state,
        addingUser: true,
        addedUser: false,
        errorAddUser: false,
      };
    case ADDED_OFFICE_USER:
      return {
        ...state,
        addingUser: false,
        addedUser: true,
        errorAddUser: false,
      };
    case ADD_FAIL_OFFICE_USER:
      return {
        ...state,
        addingUser: false,
        addedUser: false,
        errorAddUser: true,
        errorAddUserMessage: action.payload,
      };
    case RESETTING_CUSTOMER_PASSWORD:
      return {
        ...state,
        resettingCustomerPassword: true,
        resetCustomerPasswordSuccess: false,
        resetCustomerPasswordError: false,
        resetCustomerPasswordErrorMessage: '',
      };
    case RESET_CUSTOMER_PASSWORD_SUCCESS:
      return {
        ...state,
        resettingCustomerPassword: false,
        resetCustomerPasswordSuccess: true,
        resetCustomerPasswordError: false,
        resetCustomerPasswordErrorMessage: '',
      };
    case RESET_CUSTOMER_PASSWORD_FAILED:
      return {
        ...state,
        resettingCustomerPassword: false,
        resetCustomerPasswordSuccess: false,
        resetCustomerPasswordError: true,
        resetCustomerPasswordErrorMessage: action.payload,
      };
    case MAKING_CUSTOMER_OFFICE_DELINQUENT:
      return {
        ...state,
        makingCustomerOfficeDelinquent: true,
        madeCustomerOfficeDelinquent: false,
        errorMakeCustomerOfficeDelinquent: false,
      };
    case MADE_CUSTOMER_OFFICE_DELINQUENT:
      return {
        ...state,
        makingCustomerOfficeDelinquent: false,
        madeCustomerOfficeDelinquent: true,
        errorMakeCustomerOfficeDelinquent: false,
      };
    case MAKE_CUSTOMER_OFFICE_DELINQUENT_FAILED:
      return {
        ...state,
        makingCustomerOfficeDelinquent: false,
        madeCustomerOfficeDelinquent: false,
        errorMakeCustomerOfficeDelinquent: true,
        errorMakeCustomerOfficeDelinquentMessage: action.payload,
      };
    case MAKING_OFFICE_HIDE_INVOICE:
      return {
        ...state,
        makingOfficeHideInvoice: true,
        madeOfficeHideInvoice: false,
        errorMakeOfficeHideInvoice: false,
      };
    case MADE_OFFICE_HIDE_INVOICE:
      return {
        ...state,
        makingOfficeHideInvoice: false,
        madeOfficeHideInvoice: true,
        errorMakeOfficeHideInvoice: false,
      };
    case MAKE_OFFICE_HIDE_INVOICE_FAILED:
      return {
        ...state,
        makingOfficeHideInvoice: false,
        madeOfficeHideInvoice: false,
        errorMakeOfficeHideInvoice: true,
        errorMakeOfficeHideInvoiceMessage: action.payload,
      };
    default:
      return state;
  }
};

export default usersReducer;
